module.exports = __webpack_public_path__ + "img/alert-orange.ad27f8a9.svg";